module.exports = __webpack_public_path__ + "static/media/demoSticker.b8448a73.jpeg";